module.exports = __webpack_public_path__ + "img/american_express.9f6951de.svg";